import React from 'react'

import ProjectData from './ProjectData';
import Card from './Card';
function scard(value){
    return(
      <Card
  
      sourceimg={value.sourceimg}
     caption={value.caption}
        title={value.title}
     description={value.description}
     demolink={value.demolink}
     codelink={value.codelink}
   
      />
   
     );
  }

export default function Test() {
  return (
    <>
    <div className='test'>
        {ProjectData.map(scard)}

    </div>
    
  </>
  )
}
